import createAction from "@web-monorepo/infra/createAction";
import createActionCreator from "@web-monorepo/infra/createActionCreator";
import createReducer from "@web-monorepo/infra/createReducer";

// inspired by https://hackernoon.com/automate-writing-redux-reducers-with-5-lines-of-javascript-cecb79fb9a35
// If you want to create an action & reducer that manipulates frontend state, this is a nice way to do it
export default function createKeducer<T>(
  actionName: string,
  reducerFunction = (payload: T): T => payload,
  payloadCreator = (payload: Record<string, unknown>): Record<string, unknown> => payload,
) {
  const action = createAction(actionName);
  const actionCreator = createActionCreator(action, payloadCreator);
  const reducerHandler = createReducer(action, reducerFunction);
  return { reducerHandler, action, actionCreator };
}
